export enum systemFunctions {
    ProjectAction = 'ProjectAction',
    SubProjectAction = 'SubProjectAction',
    BoardAction = 'BoardAction',
    ProjectFileAction = 'ProjectFileAction',
    ProjectHistory = 'ProjectHistory',
    ProjectTeamAction = 'ProjectTeamAction',
    TaskAction = 'TaskAction',
    ColumnAction = 'ColumnAction',
    TaskMoveAction = 'TaskMoveAction',
    ColumnProxyAction = 'ColumnProxyAction',
    TaskChatAction = 'TaskChatAction',
    TaskFileAction = 'TaskFileAction',
    SystemProjectAction = 'SystemProjectAction',
    UserMonitorAction = 'UserMonitorAction',
    BasketAction = 'BasketAction',
    SystemAction = 'SystemAction',
    SystemUserAction = 'SystemUserAction',
    RoleAction = 'RoleAction',
    ArchiveAction = 'ArchiveAction',
    LicenseAction = 'LicenseAction',
    ChecklistAction = 'ChecklistAction',
    TokenAction = 'TokenAction',
    IntegrationSystemAction = "IntegrationSystemAction"
}
